import React, { useCallback } from 'react';

import SearchMapMarker from '@/components/route/search/SearchMapMarker';
import { TCurrency } from '@/config/locales';
import { IMapMarkerData } from '@/redux/selectors/search/map';

import EscapeMapMarker from '../SearchMapMarker/EscapeMapMarker';

interface IProps {
  container: Element | null;
  currency: TCurrency;
  markers: IMapMarkerData[];
  openedMarker?: number | null;
  onMarkerClick?: (id: number | null) => void;
  promoSlug?: string;
  isOnWishlist?: boolean;
}

const SearchMapMarkers: React.FC<IProps> = ({
  container,
  currency,
  markers,
  openedMarker,
  onMarkerClick,
  promoSlug,
  isOnWishlist,
}) => {
  const handleOnClick = useCallback(
    (id: number) => onMarkerClick?.(id === openedMarker ? null : id),
    [openedMarker, onMarkerClick],
  );

  return (
    <>
      {markers.map(marker => {
        if (marker.rentals.length > 0) {
          const id = marker.rentals[0]?.id;

          return (
            <SearchMapMarker
              key={id}
              isPopupVisible={id === openedMarker}
              container={container}
              currency={currency}
              onClick={handleOnClick}
              promoSlug={promoSlug}
              isOnWishlist={isOnWishlist}
              {...marker}
            />
          );
        }
      })}
      {markers.map(marker => {
        if (marker.escapes?.length) {
          const id = marker.escapes[0]?.id;

          return (
            <EscapeMapMarker
              key={id}
              isPopupVisible={id === openedMarker}
              container={container}
              currency={currency}
              onClick={handleOnClick}
              promoSlug={promoSlug}
              isOnWishlist={isOnWishlist}
              {...marker}
            />
          );
        }
      })}
    </>
  );
};

export default SearchMapMarkers;
